import React from 'react';
import { Navigate } from 'react-router-dom';
import AsyncComponent from '@/components/AsyncLoader';
import SimpleLayout from './layouts/SimpleLayout';
import LoginView from './views/Login';
import RealtimeView from './views/RealtimeView';
import SingleView from './views/SingleView';
import MainLayout from './layouts/MainLayout';
import RemoteControl from './views/RemoteControl';
import ShadowSysView from './views/ShadowSysView';
import MapEditor from './views/MapEditor';

const ChooseCockpit = AsyncComponent(
  () => import(/* webpackChunkName: "ChooseCockpit" */ './views/ChooseCockpit')
);
const WarningListView = AsyncComponent(
  () =>
    import(/* webpackChunkName: "WarningListView" */ './views/WarningListView')
);
const OperationsLogView = AsyncComponent(
  () =>
    import(
      /* webpackChunkName: "OperationsLogView" */ './views/OperationsLogView'
    )
);
const EventPlayBack = AsyncComponent(
  () => import(/* webpackChunkName: "EventPlayBack" */ './views/EventPlayBack')
);
const RoadTestPlayBack = AsyncComponent(
  () => import(/* webpackChunkName: "RoadTestPlayBack" */ './views/RoadTestPlayBack')
);
const NotFoundView = AsyncComponent(
  () =>
    import(/* webpackChunkName: "NotFoundView" */ './views/errors/NotFoundView')
);
const NoPermissionView = AsyncComponent(
  () =>
    import(
      /* webpackChunkName: "NoPermissionView" */ './views/errors/NoPermissionView'
    )
);

const WebTerminal = AsyncComponent(
  () => import(/* webpackChunkName: "NoPermissionView" */ './views/WebTerminal')
);

const PatrolMode = AsyncComponent(
  () => import(/* webpackChunkName: "PatrolMode" */ './views/PatrolMode')
);
const CockpitManage = AsyncComponent(
  () => import(/* webpackChunkName: "CockpitManage" */ './views/CockpitManage')
);
const CloudPoints = AsyncComponent(
  () => import(/* webpackChunkName: "CloudPoints" */ './views/CloudPoints')
);

const AccidentManage = AsyncComponent(
  () =>
    import(/* webpackChunkName: "AccidentManage" */ './views/AccidentManage')
);

const CollectionTask = AsyncComponent(
  () =>
    import(/* webpackChunkName: "CollectionTask" */ './views/CollectionTask')
);

const RequirementDetail = AsyncComponent(
  () =>
    import(
      /* webpackChunkName: "RequirementDetail" */ './views/RequirementDetail'
    )
);
const routes: any[] = [
  {
    path: '/',
    element: <SimpleLayout />,
    children: [
      { index: true, element: <Navigate to="/login" /> },
      { path: 'login', element: <LoginView /> },
      { path: '404', element: <NotFoundView /> },
      { path: '*', element: <NotFoundView /> },
    ],
  },
  {
    path: '/app',
    element: <MainLayout />,
    children: [
      { index: true, element: <Navigate to="realtime" /> },
      { path: '403', element: <NoPermissionView /> },
      { path: 'realtime', element: <RealtimeView /> },
      { path: 'single', element: <SingleView /> },
      { path: 'operations', element: <OperationsLogView /> },
      { path: 'warnings', element: <WarningListView /> },
      { path: 'shadowsystem', element: <ShadowSysView /> },
      { path: 'remoteControl', element: <RemoteControl /> },
      { path: 'eventplayback', element: <EventPlayBack /> },
      { path: 'roadtest-playback', element: <RoadTestPlayBack /> },
      { path: 'webterminal', element: <WebTerminal /> },
      { path: 'mapeditor', element: <MapEditor /> },
      { path: 'chooseCockpit', element: <ChooseCockpit /> },
      { path: 'patrolMode', element: <PatrolMode /> },
      { path: 'cockpitManage', element: <CockpitManage /> },
      { path: 'cloudpoints', element: <CloudPoints /> },
      { path: 'accidentmanage', element: <AccidentManage /> },
      { path: 'collectiontask', element: <CollectionTask /> },
      { path: 'requirementdetail/:id', element: <RequirementDetail /> },
    ],
  },
];

export default routes;
